import DetailSeries from './DetailSeries'

export default DetailSeries
// eslint-disable-next-line import/export
export * from './DetailSeries'
